// @vendors
const React = require('react');
const PropTypes = require('prop-types');

// @commons
const { PopoverMenu } = require('commonsComponents/popoverMenu');
const { OKButton } = require('components/commons/OKButton/OKButton');

// @helpers
const { removeCurrentSectionOption } = require('utilities/moreOptionsHelper');


class PopoverNavigationButton extends React.Component {
    buildOptions () {
        const { items } = this.props;
        return removeCurrentSectionOption(items);
    }

    render() {
        const { title, customClassName, dropdownItemStyle } = this.props;
        const options = this.buildOptions();
        const modifier = "ghost";
        const targetElement = (
            <div className="popover-navigation-button">
                <OKButton
                    modifier={modifier}
                    rightIcon="icon-dropdown-abrir"
                    smallRightIcon={true}
                    inverse
                >
                    {title}
                </OKButton>
            </div>
        );

        const content = (
            <PopoverMenu
                target={targetElement}
                items={options}
                placement="bottomRight"
                customClassName={customClassName}
                dropdownItemStyle={dropdownItemStyle}
            />
        );

        return content;
    }
}

PopoverNavigationButton.propTypes = {
    title: PropTypes.string.isRequired,
    items: PropTypes.array.isRequired,
    customClassName: PropTypes.string,
    dropdownItemStyle: PropTypes.string
};

module.exports = PopoverNavigationButton;
